import { useState, useEffect } from 'react';

/**
 * useCascadeAnimation
 * Triggers once when the referenced element enters the viewport.
 *
 * @param ref - Ref to the container element
 * @param threshold - IntersectionObserver threshold (default: 0.4)
 * @returns isVisible - true once the element becomes visible
 */
export function useCascadeAnimation(ref, threshold) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [ref, threshold]);

  return isVisible;
}
